import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { syncApi, type SyncStatusResponse } from '../api/sync';

export function useSyncStatus() {
  return useQuery<SyncStatusResponse>({
    queryKey: ['sync', 'status'],
    queryFn:  syncApi.getStatus,
    refetchInterval: (query) => {
      // Poll every 5 s while any resource is syncing
      const resources = query.state.data?.resources ?? {};
      const hasRunning = Object.values(resources).some((r) => r.status === 'running');
      return hasRunning ? 5_000 : false;
    },
  });
}

export function useTriggerSync() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (full?: boolean) => syncApi.trigger(full ?? true),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['sync', 'status'] });
    },
  });
}
